import type { PlatformTheme } from "../../api/types";
import neutralDark from "../../assets/platform-illustrations/neutral-dark.svg";
import neutralLight from "../../assets/platform-illustrations/neutral-light.svg";
import pinkDark from "../../assets/platform-illustrations/pink-dark.svg";
import pinkLight from "../../assets/platform-illustrations/pink-light.svg";
import purpleDark from "../../assets/platform-illustrations/purple-dark.svg";
import purpleLight from "../../assets/platform-illustrations/purple-light.svg";
import tealDark from "../../assets/platform-illustrations/teal-dark.svg";
import tealLight from "../../assets/platform-illustrations/teal-light.svg";
import yellowDark from "../../assets/platform-illustrations/yellow-dark.svg";
import yellowLight from "../../assets/platform-illustrations/yellow-light.svg";
import "./PlatformHeaderIllustration.css";

// One illustration per platform theme and colour mode. A platform with no theme
// is neutral.
const ILLUSTRATIONS: Record<
  PlatformTheme | "neutral",
  { dark: string; light: string }
> = {
  neutral: { dark: neutralDark, light: neutralLight },
  teal: { dark: tealDark, light: tealLight },
  purple: { dark: purpleDark, light: purpleLight },
  pink: { dark: pinkDark, light: pinkLight },
  yellow: { dark: yellowDark, light: yellowLight },
};

// An illustration at the right of a page header, in a light and a dark version.
// Both are rendered and CSS shows the one that matches the colour mode (as on
// My Hub), so it follows a change of mode, or the system's, without a reload.
export function HeaderIllustration({
  light,
  dark,
  width = 278,
}: {
  light: string;
  dark: string;
  /** The artwork's width; it is always 160px tall. */
  width?: number;
}) {
  return (
    <div className="platform-header-illustration" aria-hidden="true">
      <img
        src={light}
        alt=""
        width={width}
        height={160}
        className="platform-header-illustration-light"
      />
      <img
        src={dark}
        alt=""
        width={width}
        height={160}
        className="platform-header-illustration-dark"
      />
    </div>
  );
}

// The illustration at the right of a platform's header, for its theme.
export function PlatformHeaderIllustration({
  theme,
}: {
  theme: PlatformTheme | null | undefined;
}) {
  const { dark, light } = ILLUSTRATIONS[theme ?? "neutral"];
  return <HeaderIllustration light={light} dark={dark} />;
}
